import { getObject, setObject } from '@/services/localStorage';

export function ticket2LS(ticketId) {
    let saved = getObject('ticketus/saved') || [];
    if (saved.find(id => id === ticketId)) {
        return;
    }
    saved.unshift(ticketId);

    if (saved.length > 30) {
        saved.pop();
    }
    setObject('ticketus/saved', saved);
}

export function ticketsFromLS() {
    return getObject('ticketus/saved') || [];
}

export function removedOldTicketsFromLS(savedTickets) {
    return savedTickets?.filter(id => !id.startsWith('urn:be:ticket:') && !id.startsWith('saved-'));
}

export function deleteInLS(ticketId) {
    const saved = getObject('ticketus/saved') || [];
    setObject(
        'ticketus/saved',
        saved.filter(t => t !== ticketId)
    );
}

export function migrateTicketsLs(db) {
    const tickets = ticketsFromLS();
    if (tickets.length && tickets[0] && !tickets[0].url) {
        return db;
    }
    const ticketIds = tickets.map(ticket => ticket.url.replace('saved-', ''));
    setObject('ticketus/saved', ticketIds);
    return db;
}
